import Map from 'ol/Map.js';
import View from 'ol/View.js';
import XYZSource from 'ol/source/XYZ';
import Feature from 'ol/Feature.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import Circle from 'ol/geom/Circle.js';
import {toStringHDMS} from 'ol/coordinate.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import {OSM, Vector as VectorSource} from 'ol/source.js';
import {Circle as CircleStyle, Fill, Stroke, Style, Text} from 'ol/style.js';
import WKT from "ol/format/WKT";
import Overlay from "ol/Overlay";
import {fromLonLat, toLonLat} from 'ol/proj.js';
import {getArea} from 'ol/sphere';
import detail from '../../main.js';
import MultiPolygon from 'ol/geom/MultiPolygon';
import Polygon from 'ol/geom/Polygon';
import {defaults} from "ol/control/util";
import data from "./citizenship_countries.json"
import couleur from "./palette.json"
import "./saveSvgAsPng.js"
import {SliderPlugin} from "@syncfusion/ej2-vue-inputs";

let lesIDCaptainBirthplaces = [];
let last_item_id = []; //id du dernier element cliquer du tableau travel
let color_by_id = [];

function country_by_captain(last_name, users) {
    $.ajax({
        type: "POST",
        url: "/python/serverPython.py",
        dataType: "json",
        data: {fonction: "country_by_captain", name: last_name},
        beforeSend: function () {

        },
        error: function (x, t, m) {
            if (t === "timeout") {
                alert("got timeout");
            } else {

                alert(t + x + m);
            }

        },
        success: function (json) {


            let isContenu = false;
            let indexJson;
            let country = [];

            $.each(json, function (index, value) {

                lesIDCaptainBirthplaces.push(value.local_id)
                for (let i = 0; i < country.length; i++) {
                    if (country[i].name === value.country) {
                        isContenu = true;
                        indexJson = i;
                    }

                }

                if (isContenu) {
                    country[indexJson].occurences++;
                    country[indexJson].captain.push({
                        captain_name: value.captain_name + " (" + value.local_id + ")",
                        birthplaces: value.birthplaces
                    })

                } else {
                    country.push(
                        {
                            name: value.country,
                            occurences: 1,
                            captain: [],

                        }
                    );
                    country[country.length - 1].captain.push({
                        captain_name: value.captain_name + " (" + value.local_id + ")",
                        birthplaces: value.birthplaces
                    })

                }
            });
            isContenu = false;

            for (let i = 0; i < users.length; i++) {
                if (!lesIDCaptainBirthplaces.includes(users[i].local_id)) {
                    if (data[users[i].citizenship] !== undefined) {

                        for (let j = 0; j < country.length; j++) {
                            if (country[j].name === data[users[i].citizenship]) {
                                isContenu = true;
                                indexJson = j;
                            }

                        }

                        if (isContenu) {
                            country[indexJson].occurences++;
                            country[indexJson].captain.push({
                                captain_name: users[i].name + " (" + users[i].local_id + ")",
                                birthplaces: users[i].birthplaces,
                                citizenship: users[i].citizenship
                            })

                        } else {
                            country.push(
                                {
                                    name: data[users[i].citizenship],
                                    occurences: 1,
                                    captain: [],

                                }
                            );
                            country[country.length - 1].captain.push({
                                captain_name: users[i].name + " (" + users[i].local_id + ")",
                                birthplaces: users[i].birthplaces,
                                citizenship: users[i].citizenship,
                            })

                        }

                    }
                }

            }


            vectorCountry.setStyle(function (feature) {
                styleMap.getText().setText(feature.get('name'));
                return styleMap;
            });


            let verif = []
            vectorCountry.setStyle(function (feature) {
                verif = country.filter(item => item.name === feature.get('name'))
                if (verif.length > 0) {

                    styleMap.getText().setText(verif[0].name + " (" + verif[0].occurences + ")");
                    styleMap.getFill().setColor("#0000ff");
                    feature.setProperties({'Captain': verif[0].captain});
                    feature.setProperties({'NotEmpty': true});

                } else {
                    styleMap.getText().setText(feature.get('name'));
                    styleMap.getFill().setColor("#ffffff");
                    feature.setProperties({'NotEmpty': false});
                }
                //  styleMap.getText().setText(value.name);

                return styleMap;

            })
            that.map.setSize([document.body.offsetWidth * (45 / 100), window.innerHeight - 200]);
            setTimeout(function () {
                that.map.updateSize();
            }, 200);


        }
    });
}

let that;


var styleMap = new Style({
    fill: new Fill({
        color: 'rgba(255, 255, 255, 0.6)'
    }),
    stroke: new Stroke({
        color: '#319FD3',
        width: 1
    }),
    text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({
            color: '#000'
        }),
        stroke: new Stroke({
            color: '#fff',
            width: 3
        })
    })
});


var viewMap = new View({
    center: [249490.4603228153, 5870363.772301538],
    zoom: 4
});

var vectorCountry = new VectorLayer({
    source: new VectorSource({
        url: 'https://raw.githubusercontent.com/openlayers/ol3/6838fdd4c94fe80f1a3c98ca92f84cf1454e232a/examples/data/geojson/countries.geojson',
        format: new GeoJSON()
    }),
    style: function (feature) {
        styleMap.getText().setText(feature.get('name'));
        return styleMap;
    }
});

function testFiltres(value, flagFilter, classFilter, homeportFilter, captain_name) {


    return ((flagFilter.length > 0 && value['flag'].includes(flagFilter[0]) ||
        flagFilter.length > 1 && value['flag'].includes(flagFilter[1]) ||
        flagFilter.length > 2 && value['flag'].includes(flagFilter[2]) ||
        flagFilter.length === 0) &&
        (classFilter.length > 0 && value['class'].includes(classFilter[0]) ||
            classFilter.length > 1 && value['class'].includes(classFilter[1]) ||
            classFilter.length > 2 && value['class'].includes(classFilter[2]) ||
            classFilter.length === 0) &&
        (homeportFilter.length > 0 && value['homeport'].includes(homeportFilter[0]) ||
            homeportFilter.length > 1 && value['homeport'].includes(homeportFilter[1]) ||
            homeportFilter.length > 2 && value['homeport'].includes(homeportFilter[2]) ||
            homeportFilter.length === 0)) &&
        (value['captain'].includes(captain_name) || captain_name === "")
}

function testFiltresCaptain(value, citizenshipFilter, birthplaceFilter, ship_name) {
    return ((citizenshipFilter.length > 0 && value['citizenship'].includes(citizenshipFilter[0]) ||
        citizenshipFilter.length > 1 && value['citizenship'].includes(citizenshipFilter[1]) ||
        citizenshipFilter.length > 2 && value['citizenship'].includes(citizenshipFilter[2]) ||
        citizenshipFilter.length === 0) &&
        (birthplaceFilter.length > 0 && value['birthplace'].includes(birthplaceFilter[0]) ||
            birthplaceFilter.length > 1 && value['birthplace'].includes(birthplaceFilter[1]) ||
            birthplaceFilter.length > 2 && value['birthplace'].includes(birthplaceFilter[2]) ||
            birthplaceFilter.length === 0) &&
        (value['ship'].includes(ship_name) || ship_name === ""))
}


var vectorMap = new TileLayer({
    source: new XYZSource({
        url: 'http://tile.stamen.com/terrain/{z}/{x}/{y}.jpg'
    })
});

function JsonBarChart(searched, classFilter, flagFilter, users, homeportFilter, reverseName, classUnknow, flagUnknow) {
    let classe = [];
    let estContenu = false;
    let index = 0;

    let flag = [];
    let estContenuFlag = false;
    let indexFlag = 0;

    for (let i = 0; i < searched.length; i++) {

        if (!(classUnknow === false && searched[i].class === 'Unknow')) {
            for (let j = 0; j < classe.length; j++) {
                if (classe[j].name.trim() === searched[i].class.trim()) {
                    estContenu = true;
                    index = j;
                }
            }
            if (estContenu) {
                classe[index].occurences++;
                estContenu = false;
            } else {
                let objet = {
                    name: searched[i].class.trim(),
                    occurences: 1
                };
                classe.push(objet);
            }
        }
        if (!(flagUnknow === false && searched[i].flag === 'Unknow')) {

            for (let k = 0; k < flag.length; k++) {
                if (flag[k].name.trim() === searched[i].flag.trim()) {
                    estContenuFlag = true;
                    indexFlag = k;
                }
            }


            if (estContenuFlag) {
                flag[indexFlag].occurences++;
                estContenuFlag = false;
            } else {
                let objet = {
                    name: searched[i].flag.trim(),
                    occurences: 1
                };
                flag.push(objet);
            }
        }


    }
    let taille = 0;
    if (searched.length < 5) {
        taille = searched.length
    } else {
        taille = 5
    }
    barChart(classe, "Class", taille, classFilter, flagFilter, users, searched, homeportFilter, reverseName);
    barChart(flag, "Flag", taille, classFilter, flagFilter, users, searched, homeportFilter, reverseName);


}

function barChart(data, container, taille, classFilter, flagFilter, users, searched, homeportFilter, reverseName) {


    d3.select("#" + container).remove();
    let margin = {top: 20, right: 20, bottom: 20, left: 50};
    if (container === 'Class') {
        margin.top = 80;
    }


    let tailleWidth = document.body.offsetWidth * (40 / 100);


    let svg = d3.select(".graph" + container).append("svg")
            .attr("width", tailleWidth)
            .attr("id", container)
            .attr("height", (window.innerHeight / 2 - 160) + margin.top),
        width = +svg.attr("width") - margin.left - margin.right,
        height = +svg.attr("height") - margin.top - margin.bottom;

    svg.append('text')
        .attr('x', width / 2 + margin.left)
        .attr('y', margin.top - 10)
        .attr('text-anchor', 'middle')
        .text(container);


    let color = d3.scaleOrdinal(d3.schemeCategory10);
    let x = d3.scaleBand().rangeRound([0, width]).padding(0.1);
    let y = d3.scaleLinear().rangeRound([height, 0]);

    let g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");


    const div = d3.select("body").append("div")
        .attr("class", "tooltip")
        .style("opacity", 0);


    if (data !== null) {
        x.domain(data.map(function (d) {
            let name = d.name.toLowerCase();
            if (data.length > 10) {
                name = d.name.substring(0, 3).toLowerCase()
            }
            return name;
        }));
        y.domain([0, d3.max(data, function (d) {
            return d.occurences;
        })]);
    }


    g.append("g")
        .attr("class", "axis axis--x")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x));

    g.append("g")
        .attr("class", "axis axis--y")
        .call(d3.axisLeft(y).ticks(5))
        .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", "0.71em")
        .attr("text-anchor", "end")
        .text("Frequency");

    if (data !== null) {
        g.selectAll(".bar")
            .data(data)
            .enter().append("rect")
            .on("mouseover", function (d) {
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(container + " : " + d.name + " (" + d.occurences + ")")
                    .style("left", (d3.event.pageX + 10) + "px")
                    .style("top", (d3.event.pageY - 50) + "px");
            })
            .on("mouseout", function (d) {
                div.transition()
                    .duration(500)
                    .style("opacity", 0);
            })
            .on("click", function (d) {
                searched.length = 0;
                if (container === 'Class') {
                    if (!classFilter.includes(d.name)) {
                        classFilter.push(d.name);

                    }
                } else {
                    if (!flagFilter.includes(d.name)) {
                        flagFilter.push(d.name);

                    }

                }
                let sauv = users.filter(item => testFiltres(item, flagFilter, classFilter, homeportFilter, reverseName));


                sauv.forEach(function (value) {
                    searched.push(value)
                });
                div.transition()
                    .duration(500)
                    .style("opacity", 0);
                JsonBarChart(searched, classFilter, flagFilter, users, homeportFilter, reverseName, true, true);

            })
            .attr("class", "bar")
            .attr("fill", function (d) {
                let name = d.name;
                /*if (data.length>10)
                {
                    name = d.name.substring(0, 2)
                }*/

                return (color(name));
            })
            .attr("x", function (d) {
                let name = d.name.toLowerCase();
                if (data.length > 10) {
                    name = d.name.substring(0, 3).toLowerCase()
                }


                return x(name)
            })
            .attr("y", function (d) {
                return y(d.occurences);
            })
            .attr("width", x.bandwidth())
            .attr("height", function (d) {
                return height - y(d.occurences);
            });
    }


}


function clickMap() {


    //[popup]
    const overlay = new Overlay({
        element: document.getElementById('popup-container'),
        positioning: 'bottom-center',
        offset: [0, -10],
        autoPan: true,
        id: 1,
    });
    that.map.addOverlay(overlay);


    that.map.on('click', function (e) {
        setTimeout(function () {
            that.map.updateSize();
        }, 200);

        if (last_item_id.length > 0 && that.isSelectedItem) {
            last_item_id.forEach(function (value) {
                document.getElementById(value).style.backgroundColor = "white";

            });
        }

        let markup = '';
        var port_uhgs_id = '';
        that.map.forEachFeatureAtPixel(e.pixel, function (feature) {

            if (that.isSelectedItem) {
                document.getElementById(feature.get('id_travel')).style.backgroundColor = color_by_id[feature.get('id_travel')];
                last_item_id.push(feature.get('id_travel'));


            }

            markup += `${markup && '<hr>'}<table>`;
            if (that.radio === 'Ship') {
                markup += `<tr><th>ID travel :</th><td>${feature.get('id_travel')}</td></tr>`;
                markup += `<tr><th>Travel :</th><td>${feature.get('from_port')}-${feature.get('to_port')}</td></tr>`;
                markup += `<tr><th>Captain name :</th><td>${feature.get('captain_name')} (${feature.get('captain_id')})</td></tr>`;
                if (feature.get('guns') !== null) {
                    markup += `<tr><th>Number of guns :</th><td>${feature.get('guns')}</td></tr>`;

                }
                if (feature.get('ship_tonnage') !== null)
                    markup += `<tr><th>Capacity of tonnage :</th><td>${feature.get('ship_tonnage')} ${feature.get('ship_tonnage_u')}</td></tr>`;


            } else {

                if (feature.get('id_travel') !== undefined) {
                    markup += `<tr><th>ID travel :</th><td>${feature.get('id_travel')}</td></tr>`;
                    markup += `<tr><th>Travel :</th><td>${feature.get('from_port')}-${feature.get('to_port')}</td></tr>`;
                    markup += `<tr><th>Ship name :</th><td>${feature.get('ship_name')} (${feature.get('ship_id')})</td></tr>`;
                    if (feature.get('captain_age') !== null)
                        markup += `<tr><th>Captain age :</th><td>${feature.get('captain_age')}</td></tr>`;

                    if (feature.get('captain_status') !== null)
                        markup += `<tr><th>Captain Status  :</th><td>${feature.get('captain_status')}</td></tr>`;

                } else if (feature.get('NotEmpty')) {
                    let i = 0;
                    feature.get('Captain').forEach(function (value) {

                        if (i !== 0)
                            markup += `${markup && '<hr>'}<table>`;
                        else
                            i++;

                        markup += `<tr><th>Captain name :</th><td>${value.captain_name}</td></tr>`;
                        if (value.birthplaces !== undefined) {
                            markup += `<tr><th> Birthplace :</th><td>${value.birthplaces}</td></tr>`;

                        }
                        if (value.citizenship !== undefined) {
                            markup += `<tr><th> Citizenship :</th><td>${value.citizenship}</td></tr>`;

                        }
                        markup += '</table>';


                    });
                } else {
                    markup = ""
                }

            }

            if (markup !== "")
                markup += '</table>';

        }, {hitTolerance: 5});
        if (markup) {
            //send an event to update the display of port information in the rest of the page (listener in flux.js)

            document.getElementById('popup-content').innerHTML = markup;
            overlay.setPosition(e.coordinate);
        } else {
            overlay.setPosition();
        }
    });

    return that.map;
}

const toLower = text => {
    return text.toString().toLowerCase()
};

function testDateFiltres(item) {
    let dateFilterMin = that.rangevalue[0] + "=";
    if (that.moisMin < 10)
        dateFilterMin += "0";
    dateFilterMin += that.moisMin.toString() + "=01";

    let dateFilterMax = that.rangevalue[1] + "=";
    if (that.moisMax < 10)
        dateFilterMax += "0";
    dateFilterMax += that.moisMin.toString() + "=01";

    return !(item.min_date < dateFilterMin && item.max_date < dateFilterMin) && !(item.max_date > dateFilterMax && item.max_date > dateFilterMax)
}


export default {
    name: 'Detail',

    mounted() {
        this.image = require.context('../../img', true);

        this.map = new Map({
            controls: defaults({
                attribution: false,
                zoom: false,
                rotate: false
            }),

            target: 'mapOL',
            layers: [

                vectorCountry

            ],
            view: viewMap
        });

        that = this;
        this.map = clickMap();

        barChart(null, "Class", 0, this.classFilter, this.flagFilter, this.usersShip, this.searchedShip, this.homePortFilter, this.reverseName);
        barChart(null, "Flag", 0, this.classFilter, this.flagFilter, this.usersShip, this.searchedShip, this.homePortFilter, this.reverseName);


        d3.select("#saveButton")
            .on('click', function () {
                let current_date = new Date();
                // Get the d3js SVG element and save using saveSvgAsPng.js
                saveSvgAsPng(document.getElementsByTagName("svg")[0], "graphClass"+'_'+current_date.getDate()+'-'+(Number(current_date.getMonth())+1)+'-'+current_date.getFullYear()+'.png', {
                    scale: 2,
                    backgroundColor: "#FFFFFF"
                });
                saveSvgAsPng(document.getElementsByTagName("svg")[1], "graphFlag_"+current_date.getDate()+'-'+(Number(current_date.getMonth())+1)+'-'+current_date.getFullYear()+'.png', {
                    scale: 2,
                    backgroundColor: "#FFFFFF"
                });

            });
    },


    data() {
        return {
            radio: "Ship", //Valeur du radio button
            country: [], //Liste des country des capitaines
            search: null, //valeur de la recherche par filtre
            value: null, // valeur de la barre d'autocmplétion
            count: 0, // conteur de checkbox
            checkbox: [], //tableau comportant les checkbox coché
            searchedCaptain: [], // contient la liste des captain
            searchedShip: [], // contient la liste des ship
            filter: "name", //Filtre choisis name par défaut
            filterShip: "name", // filtre choisi pour le bateau name par défaut
            filterTravel: "id",
            isCompare: false, // true si on a cliquer sur le bouton comapré
            selectedItem: [], //Item(bateau ou capitaine) qu'on a selectioner
            objectsSearched: [], //les objets rechercher via la barre d'autocomplétion
            isSelectedItem: false, // true si on a selectioner un Item
            usersShip: [], // liste de sauvegarde pour les filtres de ship
            count_travel: 0, //count du nombre de travel
            map: Map, // carte
            layer: [], // liste des layers pour la carte
            layerHistory: [], //Historique des layers => se rempli uqnad on clique sur un bouton see

            // les deux variables servent pour comparer les voyages
            travel: [],
            travel2: [],

            usersCaptain: [],// liste de sauvegarde pour les filtres de captain
            isTravelFini: [], //variables pour savoir si un voyage est fini
            isSearching: false, // variable pour savoir si une recherche est en cours
            searchTravel: "",
            isBacking: false, //variable pour savoir si on a cliquer sur le bouton back
            isSeeingObject: false, //true quand on a cliquer sur un travel
            objectSeeing: {}, //object (capitaines/navires) qu'on est en train de voir
            objectSeeing2: {}, //object 2 (capitaines/navires) qu'on est en train de voir (rempli dans le cas de comparaison)
            isSeeingObject2: false, //true quand on a cliquer sur un travel (cas de comparaison)
            selectedItemHistory: [], //Historique de la liste des item selectionner
            travelHistory: [], //historique des travel
            radioHistory: "", //conservation de la valeur du radio bouton
            reverseRadio: [],
            reverseName: "", // valeur de la deuxième barre d'autocomplétion
            flagFilter: [], //liste des filtres pour les flags
            classFilter: [], //liste des filtres pour les class
            homePortFilter: [], //liste des filtres pour les homeports
            reverseSearched: [],
            searchLoading: [],
            birthplaceFilter: [],
            citizenshipFilter: [],
            ClassUnknow: false, //valeur de la checkbox Hide Unknown Class
            FlagUnknow: false, //valeur de la checkbox Hide Unknown Flag
            isLoadTravel: false,
            showPicture: false,
            pictures: "",
            image: "",
            rangevalue: [1769, 1896],
            minSlider: 1769,
            maxSlider: 1896,
            tooltip: {
                placement: "Before",
                isVisible: true,
            },
            ticks: {
                placement: "After",
                largeStep: 20,
                smallStep: 5,
                showSmallTicks: true,
            },
            ticksMois: {
                placement: "After",
                largeStep: 2,
                smallStep: 1,
                showSmallTicks: true,
            },
            minDate: 1769,
            maxDate: 1896,
            rangevalueMois: [1, 12],
            minSliderMois: 1,
            maxSliderMois: 12,
            afficherMois: false,
            inputMin: "1769/1",
            inputMax: "1896/12",
            moisMin: 1,
            moisMax: 1,
            oldRangeValue: [1769, 1896],
            afficherMoisMin: false,
            afficherMoisMax: false,

        }


    },
    watch: {
        isLoadTravel: function () {
            setTimeout(function () {
                that.map.updateSize();
            }, 200);
        }
    },
    methods: {


        changeRadio() // click sur un bouton radio
        {
            //this.objectsSearched = [];
            this.value = "";
            this.checkbox.length = 0;
            this.count = 0;
            this.searchedShip = [];
            this.searchedCaptain = [];
            this.restaureMap();
            this.resetSearch();


            if (this.radio === 'Ship') {
                barChart(null, "Class", 0);
                barChart(null, "Flag", 0);
            } else {

                that.map.setSize([document.body.offsetWidth * (45 / 100), window.innerHeight - 200]);
                setTimeout(function () {
                    that.map.updateSize();
                }, 200);
            }


        },


        restaureMap() // Restaure la map par défaut
        {
            vectorCountry.setStyle(function (feature) {
                styleMap.getText().setText(feature.get('name'));
                styleMap.getFill().setColor("#ffffff");

                return styleMap;
            });
        },

        sliderChange() {
            this.inputMin = this.rangevalue[0].toString() + '/' + this.moisMin.toString();
            this.inputMax = this.rangevalue[1].toString() + '/' + this.moisMax.toString();

        },

        validateValue() {
            if (this.oldRangeValue[0] !== this.rangevalue[0]) {
                this.afficherMoisMin = true;
            } else if (this.oldRangeValue[1] !== this.rangevalue[1]) {
                this.afficherMoisMax = true;
            }
            this.oldRangeValue = this.rangevalue;
            this.sliderChange();

        },


        backAnne() {
            this.afficherMoisMin = false;
            this.afficherMoisMax = false;

            if (this.radio === 'Ship') {
                this.searchedShip = this.usersShip.filter(item => testDateFiltres(item));
                JsonBarChart(this.searchedShip, this.classFilter, this.flagFilter, this.usersShip, this.homePortFilter, this.reverseName, true, true);

            }
            else
            {
                this.searchedCaptain = this.usersCaptain.filter(item => testDateFiltres(item));
                country_by_captain(this.value, this.searchedCaptain);

            }

        },

        changeMoisMin() {
            this.inputMin = this.rangevalue[0].toString() + '/' + this.moisMin.toString();

        },

        changeMoisMax() {
            this.inputMax = this.rangevalue[1].toString() + '/' + this.moisMax.toString();

        },

        searchAction() //Click sur le bouton de recherche
        {
            this.ClassUnknow = false;
            this.FlagUnknow = false;
            this.isSearching = true;
            this.usersCaptain = [];
            this.usersShip = [];
            this.searchLoading = [];

            if (this.radio === "Captain") {

                this.country = [];
                this.captain_with_name(this.usersCaptain, this.searchedCaptain, this.value, this.citizenshipFilter, this.birthplaceFilter, this.reverseName, this.searchLoading);
            } else {

                this.ship_with_name(this.usersShip, this.searchedShip, this.value, this.reverseName, this.flagFilter, this.classFilter, this.homePortFilter, this.searchLoading);
            }

        },
        getObject(searchTerm) //recherche dans la première barre d'autocomplétion
        {

            if (searchTerm.length === 3) {
                this.object_name(this.objectsSearched, searchTerm, this.radio); //Radio vaut Ship ou Captain
            } else if (searchTerm.length < 3) {
                this.objectsSearched = [];
            }


        },
        getReverse(searchTerm) //recherche dans la deuxième barre d'autocompletion
        {
            if (searchTerm.length === 3 && this.usersShip.length === 0) {
                this.object_name(this.reverseSearched, searchTerm, this.reverseRadio[this.radio]); //Radio vaut Ship ou Captain
            } else if (searchTerm.length < 3) {
                this.reverseSearched = [];
            }
            if (this.usersShip.length > 0) {
                this.searchedShip = this.usersShip.filter(item => testFiltres(item, this.flagFilter, this.classFilter, this.homePortFilter, this.reverseName))
            }
        },

        resetSearch() //fonction de réinitialisation des variables
        {
            this.ClassUnknow = false;
            this.FlagUnknow = false;
            this.value = "";
            this.reverseName = "";

            if (this.radio === 'Ship') {
                this.flagFilter = [];
                this.classFilter = [];
                this.homePortFilter = [];
                this.searchedShip = [];
                this.usersShip = [];
                JsonBarChart([]);

            } else {
                this.usersCaptain = [];
                this.searchedCaptain = [];
                this.birthplaceFilter = [];
                this.citizenshipFilter = [];
            }


        },

        modifChip() //quand on touche aux filtres (ajout/suppression)
        {


            if (this.radio === 'Ship') {
                if (this.value !== null && this.value !== "") {
                    this.searchedShip = this.usersShip.filter(item => testFiltres(item, this.flagFilter, this.classFilter, this.homePortFilter, this.reverseName))
                }
                JsonBarChart(this.searchedShip, this.classFilter, this.flagFilter, this.usersShip, this.homePortFilter, this.reverseName, true, true);

            } else if (this.value !== null && this.value !== "") {

                this.searchedCaptain = this.usersCaptain.filter(item => testFiltresCaptain(item, this.citizenshipFilter, this.birthplaceFilter, this.reverseName));
                country_by_captain(this.value, this.searchedCaptain);

            }
        },

        onSelect(item) // selection de la table captain/ship
        {

            this.isLoadTravel = true;
            this.map.getOverlayById(1).setPosition();
            this.radioHistory = this.radio;
            this.isBacking = false;
            this.map.removeLayer(vectorCountry);
            this.map.addLayer(vectorMap);
            viewMap.setCenter([249490.4603228153, 5870363.772301538]);
            viewMap.setZoom(4);

            this.isSelectedItem = true;
            if (this.radio === 'Ship') {
                //this.map=resizeMap();
                this.object_detail(this.selectedItem, item.local_id, "ship_detail", false);
                this.travel_detail(this.layer, this.map, item.local_id, "ship_id", this.travel, this.isTravelFini)

            } else {
                this.object_detail(this.selectedItem, item.local_id, "captain_detail", false);
                this.travel_detail(this.layer, this.map, item.local_id, "captain_id", this.travel)

            }


            that.map.setSize([document.body.offsetWidth * (45 / 100), window.innerHeight - 200]);
            setTimeout(function () {
                that.map.updateSize();
            }, 200);


        },
        onSelectTab3(item) // selection de la table travel
        {


            if (item !== null) {
                if (last_item_id.length > 0) {
                    last_item_id.forEach(function (value) {
                        document.getElementById(value).style.backgroundColor = "white";

                    });
                }

                document.getElementById(item.id).style.backgroundColor = color_by_id[item.id];
                last_item_id.push(item.id)

            } else {
                if (last_item_id.length > 0)
                    last_item_id.forEach(function (value) {
                        document.getElementById(value).style.backgroundColor = "white";

                    });
            }

            this.isSeeingObject = (item !== null);
            this.objectSeeing = item;

            if (!this.isCompare && this.isSeeingObject) {

                for (let i = 0; i < this.layer.length; i++) {


                    if (this.layer[i].getSource().getFeatures()[0].get('id_travel') === item.id && this.layer[i].getSource().getFeatures()[0].getGeometry() !== null) {

                        let x1 = this.layer[i].getSource().getFeatures()[0].getGeometry().getCoordinates()[0][0];
                        let x2 = this.layer[i].getSource().getFeatures()[0].getGeometry().getCoordinates()[1][0];

                        let y1 = this.layer[i].getSource().getFeatures()[0].getGeometry().getCoordinates()[0][1];
                        let y2 = this.layer[i].getSource().getFeatures()[0].getGeometry().getCoordinates()[1][1];


                        let markup = '';

                        markup += `${markup && '<hr>'}<table>`;
                        if (this.radio === 'Ship') {
                            markup += `<tr><th>ID travel :</th><td>${this.layer[i].getSource().getFeatures()[0].get('id_travel')}</td></tr>`;
                            markup += `<tr><th>Travel :</th><td>${this.layer[i].getSource().getFeatures()[0].get('from_port')}-${this.layer[i].getSource().getFeatures()[0].get('to_port')}</td></tr>`;
                            markup += `<tr><th>Captain name :</th><td>${this.layer[i].getSource().getFeatures()[0].get('captain_name')} (${this.layer[i].getSource().getFeatures()[0].get('captain_id')})</td></tr>`;
                            if (this.layer[i].getSource().getFeatures()[0].get('guns') !== null) {
                                markup += `<tr><th>Number of guns :</th><td>${this.layer[i].getSource().getFeatures()[0].get('guns')}</td></tr>`;
                            }
                            if (this.layer[i].getSource().getFeatures()[0].get('ship_tonnage') !== null) {
                                markup += `<tr><th>Capacity of tonnage :</th><td>${this.layer[i].getSource().getFeatures()[0].get('ship_tonnage')} ${this.layer[i].getSource().getFeatures()[0].get('ship_tonnage_u')}</td></tr>`;
                            }
                        } else {
                            markup += `<tr><th>ID travel :</th><td>${this.layer[i].getSource().getFeatures()[0].get('id_travel')}</td></tr>`;
                            markup += `<tr><th>Travel :</th><td>${this.layer[i].getSource().getFeatures()[0].get('from_port')}-${this.layer[i].getSource().getFeatures()[0].get('to_port')}</td></tr>`;
                            markup += `<tr><th>Ship name :</th><td>${this.layer[i].getSource().getFeatures()[0].get('ship_name')} (${this.layer[i].getSource().getFeatures()[0].get('ship_id')})</td></tr>`;
                            if (this.layer[i].getSource().getFeatures()[0].get('captain_age') !== null) {
                                markup += `<tr><th>Captain age :</th><td>${this.layer[i].getSource().getFeatures()[0].get('captain_age')}</td></tr>`;
                            }
                            if (this.layer[i].getSource().getFeatures()[0].get('captain_status') !== null) {

                                markup += `<tr><th>Captain Status  :</th><td>${this.layer[i].getSource().getFeatures()[0].get('captain_status')}</td></tr>`;
                            }

                        }

                        if (markup !== "")
                            markup += '</table>';


                        if (markup) {
                            //send an event to update the display of port information in the rest of the page (listener in flux.js)

                            document.getElementById('popup-content').innerHTML = markup;
                            if (item.sailing_around) {
                                this.map.getOverlayById(1).setPosition(([this.layer[i].getSource().getFeatures()[0].getGeometry().getCoordinates()[0]
                                    , this.layer[i].getSource().getFeatures()[0].getGeometry().getCoordinates()[1]]));
                            } else {
                                this.map.getOverlayById(1).setPosition(([(x1 + x2) / 2, (y1 + y2) / 2]));
                            }
                        } else {
                            this.map.getOverlayById(1).setPosition();
                        }
                    } else if (this.layer[i].getSource().getFeatures()[0].get('id_travel') === item.id && this.layer[i].getSource().getFeatures()[0].getGeometry() === null) {
                        let markup = '';
                        markup += `${markup && '<hr>'}<table>`;
                        markup += `<tr><th>The Travel selected doesn't have segment. Maybe because one of uhgs_id is null or invalid </td></tr>`;
                        markup += '</table>';
                        document.getElementById('popup-content').innerHTML = markup;
                        this.map.getOverlayById(1).setPosition(that.map.getView().getCenter());

                    }
                }
            } else {
                this.map.getOverlayById(1).setPosition();

            }


        },
        onSelectTab4(item) // selection de la table travel
        {
            this.isSeeingObject2 = (item != null);
            this.objectSeeing2 = item;

        },

        seeCaptain() {
            this.seeResetVar();
            this.radio = 'Captain';

            this.object_detail(this.selectedItem, this.objectSeeing.captain_id, "captain_detail", false);
            this.travel_detail(this.layer, this.map, this.objectSeeing.captain_id, "captain_id", this.travel)
        },

        getCaptain2() {

        },
        searchPicturesClass(classes) {
            this.showPicture = true;
            var imagePath = (name) => this.image(name, true);

            try {
                that.pictures = imagePath('./' + classes.toLowerCase() + '.png')
            } catch (e) {
                that.pictures = ""

            } finally {
                console.log(that.pictures)
            }

        },

        unknonDisplayClass(value) {

            if (value === true) {

                JsonBarChart(this.searchedShip, this.classFilter, this.flagFilter, this.usersShip, this.homePortFilter, this.reverseName, false, true);

            } else {
                JsonBarChart(this.searchedShip, this.classFilter, this.flagFilter, this.usersShip, this.homePortFilter, this.reverseName, true, true);

            }
        },

        unknonDisplayFlag(value) {
            if (value === true) {

                JsonBarChart(this.searchedShip, this.classFilter, this.flagFilter, this.usersShip, this.homePortFilter, this.reverseName, true, false);

            } else {

                JsonBarChart(this.searchedShip, this.classFilter, this.flagFilter, this.usersShip, this.homePortFilter, this.reverseName, true, true);

            }
        },

        seeResetVar() {
            last_item_id = [];
            this.map.getOverlayById(1).setPosition();
            for (let i = 0; i < this.layer.length; i++) {

                this.map.removeLayer(this.layer[i]);
            }

            this.isCompare = false;
            this.travelHistory = this.travel;
            this.selectedItemHistory = this.selectedItem;
            this.selectedItem = [];
            this.layerHistory = this.layer;
            this.layer = [];
            this.travel = [];
            this.isSeeingObject = false;
            this.isSeeingObject2 = false;

        },

        seeObject(radio, objectSeeing) {

            this.isCompare = false;

            this.travelHistory = this.travel;
            this.selectedItemHistory = this.selectedItem;
            this.selectedItem = [];
            this.travel = [];
            this.isSeeingObject = false;
            this.isSeeingObject2 = false;
            this.radio = radio;
            this.object_detail(this.selectedItem, objectSeeing.captain_id, this.radio.toLowerCase() + "_detail", false);
            this.travel_detail(this.layer, this.map, objectSeeing.captain_id, this.radio.toLowerCase() + "_id", this.travel, this.isTravelFini)
        },
        seeShip() {

            this.seeResetVar();
            this.radio = 'Ship';
            this.object_detail(this.selectedItem, this.objectSeeing.ship_id, "ship_detail", false);
            this.travel_detail(this.layer, this.map, this.objectSeeing.ship_id, "ship_id", this.travel, this.isTravelFini)

        },
        seeShip2() {
            this.seeResetVar();
            this.radio = 'Ship';
            this.object_detail(this.selectedItem, this.objectSeeing2.ship_id, "ship_detail", false);
            this.travel_detail(this.layer, this.map, this.objectSeeing2.ship_id, "ship_id", this.travel);
        },
        seeCaptain2() {
            this.seeResetVar();
            this.radio = 'Captain';

            this.object_detail(this.selectedItem, this.objectSeeing.captain_id, "captain_detail", false);
            this.travel_detail(this.layer, this.map, this.objectSeeing.captain_id, "captain_id", this.travel)
        },


        backTable() // click sur le bouton back
        {
            this.map.getOverlayById(1).setPosition();
            setTimeout(function () {
                that.map.updateSize();
            }, 200);

            if (this.selectedItemHistory.length > 0) {

                this.selectedItem = this.selectedItemHistory;
                this.travel = this.travelHistory;
                if (this.radio === 'Ship')
                    this.radio = 'Captain';
                else
                    this.radio = 'Ship';

                this.isSeeingObject = false;
                this.selectedItemHistory = [];
                this.travelHistory = [];
                for (let i = 0; i < this.layer.length; i++) {

                    this.map.removeLayer(this.layer[i]);
                }
                this.layer = this.layerHistory;

                this.layerHistory = [];


                for (let i = 0; i < this.layer.length; i++) {
                    this.map.addLayer(this.layer[i]);
                }

            } else {


                this.isBacking = true;


                this.resetVar();
                this.radio = this.radioHistory;
            }

            if (this.selectedItem.length === 2) {
                this.isCompare = true;
            }
        },
        /****************************************<REQUETES_AJAX>*************************************************/
        captain_with_name(users, searched, name, citizenshipFilter, birthplaceFilter, reverseName, searchLoading) {
            $.ajax({
                type: "POST",
                url: "/python/serverPython.py",
                dataType: "json",
                data: {fonction: "captain_with_name", last_name: name, shipName: reverseName},
                beforeSend: function () {

                },
                error: function (x, t, m) {
                    if (t === "timeout") {
                        alert("got timeout");
                    } else {

                        alert(t + x + m);
                    }
                    searchLoading.push(5);

                },
                success: function (json) {
                    users.length = 0;
                    searched.length = 0;


                    $.each(json, function (index, value) {
                        users.push(value);
                        users[index].id = index;
                    });

                    let sauv = users.filter(item => testFiltresCaptain(item, citizenshipFilter, birthplaceFilter, reverseName));
                    sauv = users.filter(item => testDateFiltres(item));

                    sauv.forEach(function (value) {
                        searched.push(value)
                    });
                    searchLoading.push(5);


                    country_by_captain(name, searched);


                }
            });
        },


        ship_with_name(users, searched, name, reverseName, flagFilter, classFilter, homeportFilter, searchLoading) {
            $.ajax({
                type: "POST",
                url: "/python/serverPython.py",
                dataType: "json",
                data: {
                    fonction: "ship_with_name",
                    ship_name: name,
                    captainName: reverseName,
                    FF: flagFilter,
                    CF: classFilter,
                    HF: homeportFilter
                },
                beforeSend: function () {
                },
                error: function (x, t, m) {
                    if (t === "timeout") {
                        alert("got timeout");
                    } else {

                        alert(t + x + m);
                    }

                    searchLoading.push(5)
                },
                success: function (json) {
                    users.length = 0;
                    searched.length = 0;

                    $.each(json, function (index, value) {
                        users.push(value);
                        users[index].id = index;
                    });
                    let sauv = users.filter(item => testFiltres(item, flagFilter, classFilter, homeportFilter, reverseName));
                    sauv = users.filter(item => testDateFiltres(item));

                    sauv.forEach(function (value) {
                        searched.push(value)
                    });

                    JsonBarChart(searched, classFilter, flagFilter, users, homeportFilter, reverseName, true, true);
                    searchLoading.push(5);


                }
            });
        },


        object_detail(item, id, object, compare) {
            $.ajax({
                type: "POST",
                url: "/python/serverPython.py",
                dataType: "json",
                data: {fonction: object, object_id: id},
                beforeSend: function () {

                },
                error: function (x, t, m) {
                    if (t === "timeout") {
                        alert("got timeout");
                    } else {

                        alert(t + x + m);
                    }

                },
                success: function (json) {

                    if (!compare) {
                        item.length = 0;
                    }

                    item.push(json[0]);


                    /* $.each(json, function(index, value) {
                         ship.push(value);
                     });*/
                }
            });


        },

        travel_detail(layer, map, object_id, object, travel, isTravelFini) {
            $.ajax({
                type: "POST",
                url: "/python/serverPython.py",
                dataType: "json",
                data: {fonction: 'travel_detail', id: object_id, field: object},
                beforeSend: function () {

                },
                error: function (x, t, m) {
                    if (t === "timeout") {
                        alert("got timeout");
                    } else {

                        alert(t + x + m + "for travel");
                    }

                },
                success: function (json) {
                    travel.lenght = 0;


                    if (json.length > 0) {
                        let i = 0;
                        let documentary_unit_id = [];
                        let rgb = "";
                        let shape = "";
                        $.each(json, function (index, value) {
                            travel.push(value);

                            console.log(value)

                            if (documentary_unit_id[value.documentary_unit_id] === undefined) {
                                documentary_unit_id[value.documentary_unit_id] = "rgb" + couleur[i].rgb;
                                rgb = "rgb" + couleur[i].rgb;
                                i++;
                            } else {
                                rgb = documentary_unit_id[value.documentary_unit_id];
                            }

                            color_by_id[value.id] = rgb;


                            var styles = {
                                'LineString': new Style({
                                    stroke: new Stroke({
                                        color: rgb,
                                        width: 4
                                    })
                                })
                            };

                            if (value.sailling_around) {
                                var image = new CircleStyle({
                                    radius: 8,
                                    fill: new Fill({color: rgb}),
                                    stroke: new Stroke({color: 'black', width: 1})
                                });

                                styles = {
                                    'Point': new Style({
                                        image: image
                                    }),
                                };
                            }


                            var styleFunction = function (feature) {
                                console.log(feature.getGeometry().getType())
                                return styles[feature.getGeometry().getType()];
                            };

                            if (map != null) {
                                if (value.sailling_around)
                                    value.features.geometry.coordinates = fromLonLat(value.features.geometry.coordinates);

                                var vectorSource = new VectorSource({
                                    features: (new GeoJSON()).readFeatures(value.features),
                                });

                                var vectorLayer = new VectorLayer({
                                    source: vectorSource,
                                    style: styleFunction,
                                    renderBuffer: 200,

                                });

                                map.addLayer(vectorLayer);
                                layer.push(vectorLayer);
                            }
                        });
                    } else {
                        that.isTravelFini.push(1);
                    }


                    that.isLoadTravel = false;

                }
            });


        },

        object_name(captains, term, type) {
            $.ajax({
                type: "POST",
                url: "/python/serverPython.py",
                dataType: "json",
                data: {fonction: "object_name", startName: term, object: type},
                beforeSend: function () {

                },
                error: function (x, t, m) {
                    if (t === "timeout") {
                        alert("got timeout");
                    } else {


                        alert(t + x + m);
                    }

                },
                success: function (json) {

                    $.each(json, function (index, value) {
                        captains.push(value.n);
                    });
                }
            });
        },
        /****************************************</REQUETES_AJAX>*************************************************/

        searchOnTable() // filtres de la table captain
        {
            this.searchedCaptain = this.usersCaptain;
            if (this.search) {
                this.searchedCaptain = this.usersCaptain.filter(item => item[this.filter].includes(this.search));
            }

        },
        searchOnTableShip() // filtres de la table ship
        {

            this.searchedShip = this.usersShip;
            if (this.search.length > 2) {
                if (this.usersShip.filter(item => item[this.filterShip].includes(this.search)) !== this.searchedShip) {
                    this.searchedShip = this.usersShip.filter(item => item[this.filterShip].toLowerCase().includes(this.search.toLowerCase()));
                    this.isOnce = false;

                }
            }
            JsonBarChart(this.searchedShip);

            this.isOnce = true;

        },

        resetVar() // reset les différentes variables
        {
            last_item_id = [];
            this.map.getOverlayById(1).setPosition();

            viewMap.setCenter([249490.4603228153, 5870363.772301538]);
            viewMap.setZoom(4);
            this.isCompare = false;
            this.searchTravel = "";
            this.isSeeingObject = false;
            this.objectSeeing = null;
            this.selectedItem.length = 0;
            this.checkbox.length = 0;
            this.count = 0;
            this.isSelectedItem = false;
            this.isSearching = false;

            this.count_travel = 0;
            this.travel = [];
            this.travel2 = [];

            this.map.removeLayer(vectorMap);
            this.map.addLayer(vectorCountry);

            for (let i = 0; i < this.layer.length; i++) {

                this.map.removeLayer(this.layer[i]);
            }

            this.layer = [];


        },

        searchItem(name) // clique sur le menu item qui lance une recherche
        {


            let re = /(.*),.*/; //expression régulière qui récupère le last_name d'un capitaine
            let last_name = name.replace(re, "$1");

            this.restaureMap();
            this.usersCaptain = [];
            this.usersShip = [];
            this.searchedShip = [];
            this.searchedCaptain = [];
            this.resetVar();
            this.isSearching = true;
            this.country = [];
            this.reverseName = "";


            this.value = last_name;

            if (this.radio === 'Ship') {
                this.ship_with_name(this.usersShip, this.searchedShip, last_name, this.reverseName, this.flagFilter, this.classFilter, this.homePortFilter, this.searchLoading);
            } else {
                this.captain_with_name(this.usersCaptain, this.searchedCaptain, last_name, this.citizenshipFilter, this.birthplaceFilter, this.reverseName, this.searchLoading);

            }

        },

        changeCheck(test, check) // click sur une checkbox
        {
            if (this.checkbox[test]) {
                this.count++;
            } else {
                this.count--;
            }


        },

        compare() // clique sur le bouton de comparaison
        {
            this.radioHistory = this.radio;
            this.isBacking = false;
            this.map.removeLayer(vectorCountry);
            this.map.addLayer(vectorMap);
            viewMap.setCenter([249490.4603228153, 5870363.772301538]);
            viewMap.setZoom(4);

            this.isCompare = true;
            this.isSelectedItem = true;

            for (var i = 0; i < this.checkbox.length; i++) {
                if (this.radio === 'Ship') {
                    if (this.checkbox[i]) {
                        this.object_detail(this.selectedItem, this.usersShip[i].local_id, "ship_detail", true);

                        if (this.count_travel === 0) {

                            this.travel_detail(null, null, this.usersShip[i].local_id, "ship_id", this.travel, this.isTravelFini);
                            this.count_travel++;

                        } else {
                            this.travel_detail(null, null, this.usersShip[i].local_id, "ship_id", this.travel2, this.isTravelFini)

                        }
                    }
                }

                if (this.radio === 'Captain') {
                    if (this.checkbox[i]) {
                        this.object_detail(this.selectedItem, this.usersCaptain[i].local_id, "captain_detail", true);
                        if (this.count_travel === 0) {

                            this.travel_detail(null, null, this.usersCaptain[i].local_id, "captain_id", this.travel, this.isTravelFini);
                            this.count_travel++;

                        } else {
                            this.travel_detail(null, null, this.usersCaptain[i].local_id, "captain_id", this.travel2, this.isTravelFini)

                        }

                    }
                }

            }
        }
    },
    created() {

        this.reverseRadio['Captain'] = "Ship";
        this.reverseRadio['Ship'] = "Captain";


    }
}





// WEBPACK FOOTER //
// ./src-detail/components/JS/Detail.js